
import React from 'react';
import { EmailTemplatesContainer } from './email-templates/EmailTemplatesContainer';

export function EmailTemplatesList() {
  return <EmailTemplatesContainer />;
}
